<div class="form-group mb-1">
  <label isRequired>Número de teléfono</label>
  <div
    class="flag-container"
    [ngClass]="{ 'is-invalid': phoneNumber.invalid }"
  >
    <ng-select
      name="routes"
      style="width: 15rem"
      [clearable]="false"
      [(ngModel)]="country"
      class="custom-dropdown"
      (change)="select($event)"
    >
      <ng-option *ngFor="let country of countries" [value]="country">
        <div class="opt">
          <div [class]="'flag flags ' + country.FlagCssClass"></div>
          <span>{{ country.CountryPhoneCode }}</span>
          &nbsp;
          <span>{{ country.ISOCode }}</span> &nbsp;
        </div>
      </ng-option>
    </ng-select>

    <input class="form-control" type="number" [formControl]="phoneNumber" />
  </div>
  <small class="invalid-field" *ngIf="phoneNumber.invalid && phoneNumber.touched">
    {{ phoneNumber.errors | errorMessage }}
  </small>
</div>

<div class="form-group" style="display: none">
  <intl-input-phone #phoneinput [CountryList]="countries"></intl-input-phone>
</div>
